<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import InputError from '@/components/InputError.vue';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        error?: string;
    }>();
</script>

<template>
    <div
        :class="
            cn(
                'border-secondary text-secondary flex gap-2 border-b pb-2 text-xs sm:items-center',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
